<template>
    <svg class='svg svg--nav svg--nav--line-bottom' width='52' height='1' viewBox='0 0 52 1' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <line x1='11' y1='0.25' x2='41' y2='0.25' class='svg--nav__stroke' stroke-width='0.5' vector-effect='non-scaling-stroke' />
    </svg>
</template>